
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import eventBus from "@/utils/eventBus";
import draggable from 'vuedraggable';
import SearchItem from './CustomerColumnItem.vue';

@Component({
  name: "CustomerSearchCustom",
  components: {
    draggable,
    SearchItem
  },
})
export default class extends Vue {
  private formSearch: any = {
    id: '',
    customer: '',
    type: '',
    mobile: '',
    telephone: ''
  }

  private searchArray: any = []
  private showSearchArray: any = []
  private isToggle = false
  private checkList: any = []
  private searchKey = ''
  private visiblePopover = false

  created() {
    this.searchKey = "lsjl_search" + this.$route.path;
    let index = this.searchKey.lastIndexOf("/");
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index);
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      for (let p = 0; p < localParse.length; p++) {
        localParse[p].fields = '';
      }
      this.searchArray = localParse;
    } else {
      this.searchArray = [
        { fields: this.formSearch.id, name: '客户ID', id: '1', checked: true, show: true, isClearable: true },
        { fields: this.formSearch.customer, name: '客户', id: '2', checked: true, show: true, isClearable: true },
        { fields: this.formSearch.type, name: '客户类型', id: '3', checked: false, show: true, isClearable: true },
        { fields: this.formSearch.mobile, name: '手机', id: '4', checked: false, show: true, isClearable: true },
        { fields: this.formSearch.telephone, name: '电话', id: '5', checked: false, show: true, isClearable: true },
      ]
    }
    this.showSearchArray = this.searchArray.filter((v: any) => {
      return v.show === true;
    });
  }

  handleSearch() {
    const params = {
      only_id: this.formSearch.id,
      customer_name: this.formSearch.customer,
      customer_type: this.formSearch.type,
      mobile: this.formSearch.mobile,
      phone: this.formSearch.telephone,
    };
    eventBus.$emit("customerSearch", params);
  }
  handleCleanSearch() {
    this.formSearch = {
      id: '',
      customer: '',
      type: '',
      mobile: '',
      telephone: ''
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      this.searchArray[m].fields = ''
    }
    this.handleSearch()
  }

  private formReceive(val: any, keyup: any) {
    switch (val.id) {
      case '1':
        this.formSearch.id = val.fields;
        break;
      case '2':
        this.formSearch.customer = val.fields;
        break;
      case '3':
        this.formSearch.type = val.fields;
        break;
      case '4':
        this.formSearch.mobile = val.fields;
        break;
      case '5':
        this.formSearch.telephone = val.fields;
        break;
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter((t: any) =>
      (!this.checkList.some((ele: any) => ele.id === t.id)) && t.show
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }
  resetHandle() {
    this.checkList = []
    for (let i = 0; i < this.searchArray.length; i++) {
      this.searchArray[i].checked = false
      if (this.searchArray[i].id === '1' || this.searchArray[i].id === '2') {
        this.searchArray[i].checked = true
        this.checkList.push(this.searchArray[i])
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
